
/* ==========================================
   AURE ATELIER — ANIMATIONS PREMIUM
   Shopify Vessel
   ========================================== */

(function () {
  function initAure() {

    // Uniquement sur la page d'accueil
    const path = window.location.pathname;

    const isHome =
      path === '/' ||
      /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(path);

    if (!isHome) return;

    document.body.classList.add('aure-home');

    const main = document.querySelector('main');
    if (!main) return;

    // Respect des préférences d'accessibilité
    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    // Repérer les sections Shopify
    const sections = Array.from(
      main.querySelectorAll(
        '.shopify-section, [id^="shopify-section-"]'
      )
    ).filter((element) => {
      return !element.parentElement?.closest(
        '.shopify-section, [id^="shopify-section-"]'
      );
    });

    // Repérer la bannière principale Vessel
    const hero = Array.from(
      main.querySelectorAll('.hero')
    ).find((element) => {
      return element.querySelector(
        '.hero__media-wrapper'
      );
    });

    if (hero) {
      hero.classList.add('aure-hero');

      // Identifier les blocs de texte
      const texts = Array.from(
        hero.querySelectorAll(
          'h1, h2, p, [class*="text"]'
        )
      ).filter((element) => {
        return element.textContent.trim().length > 0;
      });

      // Trouver le titre principal
      const title = texts.find((element) =>
        element.textContent.includes(
          "Bienvenue à l'Atelier"
        ) ||
        element.textContent.includes(
          "Bienvenue à l’Atelier"
        )
      );

      if (title) {
        title.classList.add('aure-hero-title');
      }

      // Trouver la phrase d'accroche
      const subtitle = texts.find((element) =>
        element.textContent.includes(
          'Un objet. Un secret'
        )
      );

      if (subtitle && subtitle !== title) {
        subtitle.classList.add(
          'aure-hero-subtitle'
        );
      }
    }

    // Détecter les galeries d'images
    sections.forEach((section) => {
      const images = section.querySelectorAll('img');

      if (
        images.length >= 3 &&
        !section.contains(hero)
      ) {
        section.classList.add('aure-gallery');
      }
    });

    // Animation au défilement
    if (!('IntersectionObserver' in window)) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(
              'aure-visible'
            );

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.05,
        rootMargin: '0px 0px -25px 0px'
      }
    );

    sections.forEach((section) => {
      // Ne pas animer la bannière entière
      if (hero && section.contains(hero)) {
        return;
      }

      // Éviter d'animer les éléments vides
      if (
        !section.textContent.trim() &&
        !section.querySelector('img, video')
      ) return;

      // Ne pas cacher les sections déjà visibles
      const rect = section.getBoundingClientRect();

      if (rect.top < window.innerHeight) {
        section.classList.add('aure-visible');
        return;
      }

      section.classList.add('aure-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAure,
      { once: true }
    );
  } else {
    initAure();
  }
})();
